import { render, staticRenderFns } from "./ClinicTable.vue?vue&type=template&id=3db41adf&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ClinicTable.vue?vue&type=script&lang=js"
export * from "./ClinicTable.vue?vue&type=script&lang=js"
import style0 from "./ClinicTable.vue?vue&type=style&index=0&id=3db41adf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db41adf",
  null
  
)

export default component.exports